export enum ActionTypes {
  SET_CURRENT_EDIT = 'editProject/SET_CURRENT_EDIT',
  SET_IS_EDITED = 'editProject/SET_IS_EDITED',
  SET_SCALE = 'editProject/SET_SCALE',
  ADD_MEASURE_LINE = 'editProject/ADD_MEASURE_LINE',
  REMOVE_MEASURE_LINE = 'editProject/REMOVE_MEASURE_LINE',
  CHANGE_MEASURE_LINE = 'editProject/CHANGE_MEASURE_LINE',
  UPDATE_MEASURES = 'editProject/UPDATE_MEASURES',
  SET_AREA = 'editProject/SET_AREA',
  CHANGE_AREA = 'editProject/CHANGE_AREA',
  DELETE_AREA = 'editProject/DELETE_AREA',
  CLEAN_HISTORY = 'editProject/CLEAN_HISTORY',
  CHANGE_AREA_POINTS = 'editProject/CHANGE_AREA_POINTS',
  ADD_TO_CURRENT_POINTS = 'editProject/ADD_TO_CURRENT_POINTS',
  CLEAR_CURRENT_POINTS = 'editProject/CLEAR_CURRENT_POINTS',
  SET_CURRENT_POINTS = 'editProject/SET_CURRENT_POINTS',
  REMOVE_LAST_CURRENT_POINT = 'editProject/REMOVE_LAST_CURRENT_POINT',
  PROJECT_UPDATED = 'editProject/PROJECT_UPDATED',
  SET_EDITED_PAGE = 'editProject/SET_EDITED_PAGE',
  UNDO = 'editProject/UNDO',
  UPDATE_LINEAR_LINES = 'editProject/UPDATE_LINEAR_LINES',
  UPDATE_COUNTS = 'editProject/UPDATE_COUNTS',
  UPDATE_COMMENTS = 'editProject/UPDATE_COMMENTS',
  UPDATE_POLYGONS = 'UPDATE_POLYGONS',
  SET_UP = 'SET_UP',
  UPDATE_FREE_HAND_SHAPES = 'UPDATE_FREE_HAND_SHAPES',
  UPDATE_PEN_SHAPES = 'UPDATE_PEN_SHAPES',
  UPDATE_CLOUD_SHAPES = 'UPDATE_CLOUD_SHAPES',
  UPDATE_TEXT_SHAPES = 'UPDATE_TEXT_SHAPES',
  BATCH_DELETE_SHAPES = 'BATCH_DELETE_SHAPES',

}
